import { render, staticRenderFns } from "./AddFeedbackRemark.vue?vue&type=template&id=b31ec41c&scoped=true&"
import script from "./AddFeedbackRemark.vue?vue&type=script&lang=js&"
export * from "./AddFeedbackRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31ec41c",
  null
  
)

export default component.exports